import React, { FunctionComponent, useState, useEffect } from "react";
import {  Table } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../useTableStyle";
import { useResyncConfStyles } from "../useResyncConfStyles";
import { Select } from "../../Select";
import { SnackBar } from "../../SnackBar";
import { useStore } from "../../../store";
import moment from "moment";
import { Formik, Form, ErrorMessage } from "formik";
import { Grid, Paper, Typography } from "@material-ui/core";
import * as Yup from "yup";
import { api } from "../../../api";
import { ThemeProvider } from "@mui/material/styles";

interface resyncProps {
  serviceList: any;
}

export const ResyncConfTablesList: FunctionComponent<resyncProps> = ({
  serviceList,
}) => {
  const getMuiTheme = useTableStyles();
  const classes = useResyncConfStyles();
  const [terminals] = useStore("terminals");
  const [serviceLogData, setServiceLogData] = useState<Array<object>>([]);
  const [service_list, setServiceList] = useState<Array<object>>([]);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [resyncStatus, setResyncStatus] = useState<string>("");
  const [posFlag, SetPosFlag] = useState<boolean>(false);

  useEffect(() => {
    getServices(serviceList);
  }, []);
  const getServices = (serviceList: any) => {
    const servicesToLoad =
      serviceList &&
      serviceList.map((item: { [key: string]: any }) => ({
        value: item.service_name,
        label: item.display_name,
      }));
    setServiceList(servicesToLoad);
    return servicesToLoad;
  };

  const getServiceLogData = async (servicename: string) => {
    try {
      const result: any = await api.get(`services/sync/${servicename}/logs`);

      if (result !== undefined) {
        setSnackbarColor("green");

        setServiceLogData(result);
        return result;
      }
    } catch (error) {
      setSnackbarColor("red");
    }
  };
  const onCloseSnackbar = () => {
    setResyncStatus("");
  };
  const emptyOptions = {
    pagination: false,
    selectableRows: undefined,
    selectableRowsHeader: false,
    print: false,
    search: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: false,
      yAxis: true,
    },

    isRowSelectable: function () {
      return false;
    },
  };

  const columns = posFlag
    ? ["Table", "Terminal", "Last Synchronised On"]
    : ["Table", "Last Synchronised On"];
  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: false,
      yAxis: true,
    },

    isRowSelectable: function () {
      return false;
    },
  };
  const validationSchema = Yup.object({
    service: Yup.string().required("Required"),
  });

  return (
    <div>
      <SnackBar
        status={resyncStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Paper
        style={{ minHeight: "25em", minWidth: "50%" }}
        className={classes.paper}
      >
        <Grid item>
          <Formik
            enableReinitialize
            onSubmit={(values) => {}}
            initialValues={{
              service: "",
            }}
            validationSchema={validationSchema}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Grid container direction="row">
                  <Grid item xs>
                    <Grid container spacing={5} className={classes.fieldSpace}>
                      <Grid item xs={6}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left" }}
                            className={classes.fieldLabelStyles}
                          >
                            Services
                          </Typography>
                          <div style={{ zIndex: 1000 }}>
                            <Select
                              menuPortalTarget={document.body}
                              menuPosition={"fixed"}
                              onChange={(e: any) => {
                                setFieldValue("service", e.value);

                                if (
                                  e.value === "pos-store" ||
                                  e.value === "store-pos"
                                ) {
                                  SetPosFlag(true);
                                } else SetPosFlag(false);

                                getServiceLogData(e.value);
                              }}
                              options={service_list}
                              value={
                                values.service
                                  ? service_list.find(
                                      (e: any) => e.value === values.service
                                    )
                                  : null
                              }
                            />
                          </div>
                          <ErrorMessage name="service">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </Grid>
                      </Grid>
                    </Grid>
                    <div className={classes.root}>
                      <Grid
                        item
                        xs={12}
                        style={{ marginLeft: "2em", marginRight: "2em" }}
                      >
                        <Table>
                          <ThemeProvider theme={getMuiTheme}>
                            <MUIDataTable
                              title={"Configuration List"}
                              data={
                                serviceLogData &&
                                serviceLogData.map((ser: any) => {
                                  if (!posFlag) {
                                    return [
                                      ser.table_name,
                                      moment(ser.last_synchronised_on).format(
                                        "DD-MM-YYYY h:mm:ss a"
                                      ),
                                    ];
                                  } else {
                                    const terminal_name =
                                      terminals &&
                                      terminals?.find(
                                        (item: any) =>
                                          item.id === ser?.terminal_id
                                      ).name;

                                    return [
                                      ser.table_name,
                                      terminal_name,
                                      moment(ser.last_synchronised_on).format(
                                        "DD-MM-YYYY h:mm:ss a"
                                      ),
                                    ];
                                  }
                                })
                              }
                              columns={columns}
                              options={options}
                            />
                          </ThemeProvider>
                        </Table>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Paper>
    </div>
  );
};
